import { formatPhoneNumber } from './format/util.js';
import { getRawPhoneNumber } from './get-raw/util.js';
import { maskPhoneNumber } from './mask/util.js';

const phoneNumber = {
    format: formatPhoneNumber,
    getRaw: getRawPhoneNumber,
    mask: maskPhoneNumber,
};

export { phoneNumber };
